import ajax from '@/modules/ajax';
import CreditCard from '@/modules/credit_card';
import Helper from '@/modules/helper';
import I18n from '@/modules/i18n';
import Switcher from '@/modules/switcher';

export default class Checkout {
  constructor(options) {
    this.contentBoleto = $('[data-content="boleto"]');
    this.contentCreditCard = $('[data-content="credit_card"]');
    this.form = document.querySelector('[data-form]');
    this.options = options;
    this.paymentMethodField = $('[data-payment-method-field]');
    this.paymentStep = $('[data-payment-step]');

    this.boletoValidatedFields = this.contentBoleto.find('[data-validaty]');
    this.creditCardValidatedFields = this.contentCreditCard.find('[data-validaty]');
  }

  bindSwitcher() {
    new Switcher({ callback: this.onSwitcherCallback.bind(this) }).create();
  }

  charge(formValidator) {
    // TODO: remove this modal from formValidator
    formValidator.showModal(I18n.t('checkout.loading_message'));

    ajax({
      done: (json) => Helper.goTo(this.options.redirect_uri.replace(':id', json.id)),
      fail: (_notify, response) => formValidator.showErrors(response),
      form: this.form,
      method: 'POST',
      url: this.options.charge_uri,
    });
  }

  create() {
    new CreditCard({ form: this.form, success: (formValidator) => this.charge(formValidator) }).init();

    this.bindSwitcher();
  }

  onSwitcherCallback(payment_method) {
    this.paymentMethodField.val(payment_method);
    this.paymentStep.find('[data-validaty-ignore]').removeAttr('data-validaty-ignore');

    const fieldsToIgnore = {
      boleto: this.creditCardValidatedFields,
      credit_card: this.boletoValidatedFields,
      pix: this.creditCardValidatedFields,
    }[payment_method];

    // Boleto has no more specific fields.
    if (fieldsToIgnore) {
      for (let i = 0; i < fieldsToIgnore.length; i++) {
        const field = fieldsToIgnore[i];

        field.dataset.validatyIgnore = field.dataset.validaty;
      }
    }
  }
}
